import React from 'react';
import {withSnackbar} from "notistack";
import { Link } from "react-router-dom";
import {forceLogout, getSchoolId, setSchoolAbbreviationName, setSchoolId} from "../../utils/authority";
import {isBrowser} from 'react-device-detect';
import UserController from "../../services/system/user/user-controller";
import {toast} from "react-toastify";
import AdSchoolInfoManager from "../../services/system/school-info/ad-school-info-manager";
import lang from '../lang';
import './styles.css';

const LANGUAGES = [
    { code: 'vi', name: 'Tiếng Việt', flag: '/images/vn.png' },
    { code: 'en', name: 'English', flag: '/images/us.png' },
    { code: 'kr', name: '한국어', flag: '/images/kr.png' }
];

class HeaderAfterLogin extends React.Component {
    static defaultProps = {
        account: {},
        isUploadDone: false,
        avatarInfo: {},
        isFetching: false,
    }

    constructor(props) {
        super(props);
        this.state = {
            avatar: null,
            userFullName: '',
            schoolName: '',
            currentLang: localStorage.getItem('sas_school_language') || 'vi',
            showLangDropdown: false,
            showUserDropdown: false
        }
    }

    componentDidMount() {
        this.getProfile();
        this.getListSchool();
        document.addEventListener('click', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
    }

    handleClickOutside = (event) => {
        if (!event.target.closest('.language-dropdown') && !event.target.closest('.user-dropdown')) {
            this.setState({
                showLangDropdown: false,
                showUserDropdown: false
            });
        }
    }

    onChangeLang = (langCode) => {
        localStorage.setItem('sas_school_language', langCode);
        this.setState({ showLangDropdown: false });
        window.location.reload();
    }

    getProfile() {
        UserController.detailSelf(res => {
            if (res.success && res.data) {
                this.setState({
                    userFullName: res.data.fullName || '',
                    avatar: res.data.avatar || null
                });
            } else {
                toast.error("Đã có lỗi xảy ra trong quá trình lấy dữ liệu, vui lòng tải lại trang!");
            }
        });
    }

    getListSchool = () => {
        let payload = {
            pageNumber: 0,
            pageSize: 10,
            sort: "created_at desc"
        };
        AdSchoolInfoManager.getListSchool(payload, res => {
            if (res.success && res.data && res.data.content && res.data.content.length > 0) {
                if (getSchoolId() === undefined) {
                    setSchoolId(res.data.content[0].id);
                    setSchoolAbbreviationName(res.data.content[0].abbreviationName);
                }
                this.setState({
                    schoolId: res.data.content[0].id,
                    schoolName: res.data.content[0].name || '',
                });
            }
        });
    }

    toggleLangDropdown = (e) => {
        e.stopPropagation();
        this.setState(prev => ({
            showLangDropdown: !prev.showLangDropdown,
            showUserDropdown: false
        }));
    }

    toggleUserDropdown = (e) => {
        e.stopPropagation();
        this.setState(prev => ({
            showUserDropdown: !prev.showUserDropdown,
            showLangDropdown: false
        }));
    }

    getCurrentLangInfo = () => {
        return LANGUAGES.find(lang => lang.code === this.state.currentLang) || LANGUAGES[0];
    }

    getInitials = (name) => {
        if (!name) return 'U';
        const words = name.trim().split(' ');
        if (words.length >= 2) {
            return (words[0][0] + words[words.length - 1][0]).toUpperCase();
        }
        return name.substring(0, 2).toUpperCase();
    }

    render() {
        const { userFullName, schoolName, showLangDropdown, showUserDropdown, currentLang } = this.state;
        const currentLangInfo = this.getCurrentLangInfo();

        return (
            <div className="header-wrapper">
                <div className="header-container">
                    {/* Logo Section */}
                    <div className="header-logo-section">
                        <Link to="/ad-sas-school" className="header-logo">
                            <img src="/images/logo_sas.png" alt="Logo" />
                        </Link>
                        <div className="header-info">
                            <h1 className="header-system-name">SAS CMS</h1>
                            <p className="header-school-name" title={schoolName}>{schoolName}</p>
                        </div>
                    </div>

                    {/* Header Actions */}
                    {isBrowser && (
                        <div className="header-actions">
                            {/* Language Dropdown */}
                            <div className={`language-dropdown ${showLangDropdown ? 'open' : ''}`}>
                                <button
                                    className="language-btn"
                                    onClick={this.toggleLangDropdown}
                                    type="button"
                                >
                                    <img src={currentLangInfo.flag} alt={currentLangInfo.name} />
                                    <span>{currentLangInfo.name}</span>
                                    <i className="fas fa-chevron-down"></i>
                                </button>
                                <div className="language-menu">
                                    {LANGUAGES.map((language) => (
                                        <div
                                            key={language.code}
                                            className={`language-item ${currentLang === language.code ? 'active' : ''}`}
                                            onClick={() => this.onChangeLang(language.code)}
                                        >
                                            <img src={language.flag} alt={language.name} />
                                            <span>{language.name}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* User Dropdown */}
                            <div className={`user-dropdown ${showUserDropdown ? 'open' : ''}`}>
                                <button
                                    className="user-btn"
                                    onClick={this.toggleUserDropdown}
                                    type="button"
                                >
                                    <div className="user-avatar">
                                        {this.state.avatar ? (
                                            <img
                                                src={this.state.avatar}
                                                alt={userFullName}
                                                onError={(e) => { e.target.style.display = 'none'; }}
                                            />
                                        ) : this.getInitials(userFullName)}
                                    </div>
                                    <span className="user-name">{userFullName}</span>
                                    <i className="fas fa-chevron-down"></i>
                                </button>
                                <div className="user-menu">
                                    <div className="user-menu-header">
                                        <p className="user-fullname">{userFullName}</p>
                                        <p className="user-role">{schoolName}</p>
                                    </div>
                                    <Link
                                        to="/ad-sas-school/quan-ly-thong-tin-ca-nhan"
                                        className="user-menu-item"
                                        onClick={() => this.setState({ showUserDropdown: false })}
                                    >
                                        <i className="fas fa-user"></i>
                                        <span>{lang.header?.profile || 'Thông tin cá nhân'}</span>
                                    </Link>
                                    <div
                                        className="user-menu-item logout"
                                        onClick={forceLogout}
                                    >
                                        <i className="fas fa-sign-out-alt"></i>
                                        <span>{lang.header?.logout || 'Đăng xuất'}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Mobile Menu Button */}
                    <button
                        className="mobile-menu-btn"
                        type="button"
                        onClick={() => this.props.toggleSidebarMobile()}
                    >
                        <i className="fas fa-bars"></i>
                    </button>
                </div>
            </div>
        );
    }
}

export default withSnackbar(HeaderAfterLogin);
